<template>
  <div class="scenario-end-screen">
    <h2 class="-large-title">Scenario finished</h2>
    <div class="info" v-if="nextScenario">
      <p>Scenario completed. Well done! <br>Get ready for the next one.</p>
      <router-link 
        class="btn"
        :to="'/trainee/scenario/'+nextScenario.id+'/playlist/'+nextScenario.playlists[0]">
        <span>Next scenario</span>
        <i class="material-icons">arrow_forward</i>
      </router-link>
    </div>
    <div class="info" v-else>
      <p>Thank you for participating. This concludes our exercise.</p>
      <router-link 
        class="btn" to="/">
        <span>Finish</span>
        <i class="material-icons">arrow_forward</i>
      </router-link>
    </div>
    <img src="@/assets/background-finished.svg" class="image" alt="Please wait" />
  </div>
</template>

<script>
  export default {
    name: "scenario-finished",
    props: {
      nextScenario: {
        type: Object
      },
    },
    mounted () {
      this.$store.dispatch('traineeStatusModule/setViewedIntro', false);
    }
  }
</script>

<style lang="scss" scoped>
.scenario-end-screen {
  grid-area: smain;
  padding: 20px;
  // background-image: url('~@/assets/background-finished.svg');
  // background-repeat: no-repeat;
  // background-position: top right;
  // background-size: auto 100%;
  // height: 400px;

  display: grid;
  grid-template-areas: 
    "title image"
    "info image";
  grid-template-columns: 2fr 1.2fr;
  grid-template-rows: min-content 500px;
  
  h2 {
    grid-area: title;
  }
  .info {
    grid-area: info;
  }
  .btn {
    display: inline-flex;
  }
  .image {
    grid-area: image;
    max-width: 100%;
  }
  p {
    font-size: 20px;
    color: #3D3DDE;
    max-width: 400px;
  }
}
@media all and (max-width: 767px) {
  .scenario-end-screen {      
    grid-template-areas: 
      "title"
      "info"
      "image";
    grid-template-columns: 1fr;
    grid-template-rows: min-content min-content 500px;
  }
  h2 {
    font-size: 36px;
  }
  p {
    font-size: 18px;
  }
  .image { 
    margin-top: 25px;
  }
}
</style>